import PatientRequest from './patient-request';

export default PatientRequest;
